export default __webpack_public_path__ + "98bef451ec4c782b56ccee40d590ca16.png";